import endpoints from '@/utils/constants';
import { apiHelper } from '@/utils/helpers';
const actions = {

  // routes needs no authentication
  getUserByPhone(_, phone) {
    return new Promise((resolve, reject) => {
      apiHelper.call('get', `${endpoints.BASE_URL}/api/v2/users/by/phone/${phone}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res)
          }
        }).catch(err => {
          reject(err);
        })
    })
  },

  getServiceCategories(context) {
    return new Promise((resolve, reject) => {
      apiHelper.call('get', `${endpoints.BASE_URL}/api/v2/service-categories`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
            context.commit('setCategories', res.data);
          }
        }).catch(err => {
          reject(err);
        })
    })
  },

  getSubcategoriesByCategoryId(context, categoryId) {
    return new Promise((resolve, reject) => {
      apiHelper.call('get', `${endpoints.BASE_URL}/api/v2/services/service-category/${categoryId}`)
        .then(res => {
          if (res.status === 200) {
            context.commit('setSubcategories', res.data)
          }
        }).catch(err => {
          reject(err);
        })
    })
  },

  getServiceJobs(context, subcategoryId) {
    return new Promise((resolve, reject) => {
      apiHelper.call('get', `${endpoints.BASE_URL}/api/v2/service-jobs/services/${subcategoryId}`)
        .then(res => {
          if (res.status === 200) {
            context.commit('setJobs', res.data)
          }
        }).catch(err => {
          reject(err);
        })
    })
  },

  getVendorList(context) {
    return new Promise((resolve, reject) => {
      apiHelper.call('get', `${endpoints.BASE_URL}/api/v2/vendors`).then((res) => {
        if (res.status === 200) {
          context.commit('setVendorList', res.data);
        }
      }).catch(err => {
        reject(err);
      })
    })
  },

  saveServiceRequest(context, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.BASE_URL}/api/v2/service-requests`,
          payload
        )
        .then(res => {
          if (res.status === 201) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getAdminUser(context) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}/api/v2/users/by/role/admin`)
        .then(res => {
          if (res.status === 201) {
            context.commit("setAdminUser", res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getUserAddresses(_, userId) {
    return new Promise((resolve, reject) => {

      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}/api/v2/users/${userId}/addresses`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export default actions;
